import React from "react";
import Reveal from "./Reveal";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { PROPERTIES, CONTACT } from "../mock";

const Properties = () => {
  return (
    <section
      id="properties"
      data-testid="properties-section"
      className="bg-[#FAF8F3] text-[#18324F] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <Reveal>
            <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
              Featured Properties
            </p>
            <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6 max-w-xl">
              Addresses of <span className="italic text-[#B88A3B]">distinction</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 border-b border-[#B88A3B] pb-1 text-sm uppercase tracking-[0.2em] text-[#18324F] hover:text-[#B88A3B] transition-colors duration-300"
            >
              Request full portfolio <ArrowUpRight size={16} />
            </a>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {PROPERTIES.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08} className="group">
              <div className={`overflow-hidden ${i === 1 ? "md:mt-12" : ""}`}>
                <div className={`overflow-hidden aspect-[4/5] ${p.fit === "contain" ? "bg-[#EFEAE2]" : ""}`}>
                  <img
                    alt={p.title}
                    data-testid={`property-image-${i}`}
                    className={`w-full h-full ${p.fit === "contain" ? "object-contain" : "object-cover"} group-hover:scale-105 transition-transform duration-700`}
                    src={p.image}
                  />
                </div>
                <div className="pt-6 border-t border-[#18324F]/10 mt-6 flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-serif-lux text-2xl font-medium tracking-tight">
                      {p.title}
                    </h3>
                    <p className="uppercase tracking-[0.2em] text-xs text-[#18324F]/50 mt-2">
                      {p.location}
                    </p>
                    <p className="text-sm text-[#18324F]/65 mt-2">{p.desc}</p>
                    {p.link && (
                      <a
                        href={p.link}
                        data-testid="belair-details-link"
                        className="inline-flex items-center gap-2 mt-4 border-b border-[#B88A3B] pb-1 text-xs uppercase tracking-[0.2em] hover:text-[#B88A3B] transition-colors duration-300"
                      >
                        View details · Ver detalles <ArrowUpRight size={14} />
                      </a>
                    )}
                  </div>
                  <p className="font-serif-lux text-xl text-[#B88A3B] whitespace-nowrap">
                    {p.price}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div
            data-testid="properties-contact-cta"
            className="mt-20 pt-10 border-t border-[#18324F]/10 flex flex-col sm:flex-row sm:items-center justify-between gap-6"
          >
            <p className="font-serif-lux italic text-2xl sm:text-3xl text-[#18324F]">
              For any info, you can <span className="text-[#B88A3B]">contact me</span>
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="properties-contact-whatsapp"
                className="inline-flex items-center gap-2 bg-[#B88A3B] text-white px-6 py-3 text-sm uppercase tracking-[0.2em] hover:bg-[#18324F] transition-colors duration-300"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
              <a
                href="#contact"
                data-testid="properties-contact-link"
                className="inline-flex items-center gap-2 border border-[#18324F]/30 px-6 py-3 text-sm uppercase tracking-[0.2em] hover:border-[#B88A3B] hover:text-[#B88A3B] transition-colors duration-300"
              >
                Contact me <ArrowUpRight size={16} />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Properties;
